export default __webpack_public_path__ + "static/media/item5.9ebfb850.jpg";